<template>
  <!-- 柱状图2 -->
    <div :id="barChart2Info.nodeId"></div>
</template>

<script>
import hot from "@/assets/images/hot.png"
export default {
  name: "BarChart2",
  props:["barChart2Info","onClick",],
  data(){
    return {
      // barChart2Info:{
      //     nodeId:'detailedData',//节点
      //     data: [2.0, 4.9, 7.0, 23.2, 25.6, 76.7, 135.6, 162.2, 32.6, 20.0, 6.4, 3.3],//数据
      //     xAxisData:['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
      //     min:0, //y轴的最小值
      //     max:180, //y轴最大值
      //     interval:30, //值之间的间隔
     //      yAxisName: '分数',
      // }
    }
  },
  computed:{

  },
/*   watch: {
    barChart2Info: {
      handler(val) {
        console.log("val", val)
      },
      deep: true,
      immediate: true
    }
  }, */
  methods:{
    barChart2(barChart2Info){
      // barChart2Info.data.reverse()
      // barChart2Info.xAxisData.reverse()
      if(!barChart2Info.formatter){
        if(barChart2Info.unit==='%'){
          barChart2Info.formatter = function (params){
            let vals=params[0].data+barChart2Info.unit
            return '<div>'+params[0].name+'</div><div>'+ params[0].seriesName+' : '+ vals+'</div>'
          }
        }else{
          barChart2Info.formatter = function (params) {
            let vals=params[0].data
            if(vals>=10000){
              vals=(vals/10000).toFixed(0)+'w'
            }
            return '<div>'+params[0].name+'</div><div>'+ params[0].seriesName+' : '+ vals+'</div>'
          }
        }
      }

      this.$echarts.dispose(document.getElementById(barChart2Info.nodeId));
      var myChart = this.$echarts.init(document.getElementById(barChart2Info.nodeId));
      myChart.setOption({
        tooltip: {
          trigger: 'axis',
          confine: true,//浮窗不超出屏幕范围
          textStyle: {
            fontSize: 12,
            color: '#333'
          },
          backgroundColor: '#fff',
          borderRadius: 4,
          axisPointer : {            // 坐标轴指示器，坐标轴触发有效
            type : 'line',         // 默认为直线，可选为：'line' | 'shadow'
            lineStyle : {          // 直线指示器样式设置
                color: '#333',
                width: 0.2,
                type: 'solid'
            },
            z: 2,//竖线在圆圈后面
          },
          extraCssText:'box-shadow:0 0 18px rgba(0,0,0,0.2)',//提示框阴影
          formatter:barChart2Info.formatter,
          // formatter:function(params){
          //   return params
          //   // return (  '<div style = "text-align:center">' +  '功率 ' + ':' + 1 + '<br/>' + '转速' + ':' + 1 + '<br/>' + '时间' + ':' + 1 + '(h)')  + '</div>';
          //   return (  '<div style="width: 320px;height: 128px;padding: 17px;box-sizing: border-box;"><div style="float: left;width: 94px;height: 94px;margin-right: 13px;border-radius: 4px;overflow: hidden;"><img src="'+
          //   'https://img11.18183.com/ku18183/image/2020/04/15/351ac9d657d10ae805fb5e7e2923fd0a.jpg'+'" alt="" style="width:100%;height:100%;"></div><div style="font-size: 12px;font-family: Microsoft YaHei;font-weight: 400;color: #333333;"><p style="overflow: hidden;text-overflow:ellipsis;white-space: nowrap;">'+
          //   "{c1}"+'</p><span style="margin-right: 13px;">'+
          //   '123w'+'</span><b>'+'17.37w'+'</b><p>'+'2021-07-13 09:00'+'</p></div></div>');
          // }
        },
        grid: {
              x:60,
              y:40,
              x2:60,
              y2:36,
              right:100,
        },
        // calculable: true,
        xAxis: {
          type:'category',
          show:barChart2Info.xShow?false:true,
          // data: ['1月 周一', '2月 周二', '3月 周二', '4月 周二', '5月 周二', '6月 周二', '7月', '8月', '9月', '10月', '11月', '12月']
          // .map(function(str){
          //   return str.replace(' ','\n')
          // }),
          // data: ['1月'+<br/>+'123', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
          data: barChart2Info.xAxisData,
          axisLine:{
              show:true,//去除y轴线
              lineStyle: {
                  color: '#ccc',
                  width: 0.8, //这里是为了突出显示加上的
              }
          },
          axisLabel: {
            show: barChart2Info.axisLabel !== false,
            interval:0,
            textStyle: {
                color:  '#999' , //坐标字值得具体的颜色
            },
		        formatter:function(value)
		        {
		          var ret = "";//拼接加\n返回的类目项
		          var maxLength = 6;//每项显示文字个数
		          var valLength = value.length;//X轴类目项的文字个数
		          var rowN = Math.ceil(valLength / maxLength); //类目项需要换行的行数
		          if (rowN > 1)//如果类目项的文字大于5,
		          {
		              for (var i = 0; i < rowN; i++) {
		                  var temp = "";//每次截取的字符串
		                  var start = i * maxLength;//开始截取的位置
		                  var end = start + maxLength;//结束截取的位置
		             //这里也可以加一个是否是最后一行的判断，但是不加也没有影响，那就不加吧
		                  temp = value.substring(start, end) + "\n";
		                  ret += temp; //凭借最终的字符串
		              }
		              return ret;
		          }
		          else {
		                     return value;
		          }
		        }
          },
          axisTick:{
              show:false//去除y轴刻度
          },
          triggerEvent: barChart2Info.triggerEvent || false
        },
        yAxis:{
          type: 'value',
          scale:true,
          name: barChart2Info.yAxisName,
          // min:barChart2Info.min, //y轴的最小值
          // max:barChart2Info.max, //y轴最大值
          // interval:barChart2Info.interval, //值之间的间隔
          // gridIndex: 1,
          nameTextStyle:{
            padding:[0,0,10,-40],
            color:"#999",
          },
          splitLine:{
            show: true,
            lineStyle:{
                type:'dashed',
                color:"#ddd",
                width:0.6
            },
          },//去除网格线
          axisLabel:{
            formatter:function (value) {
              var txt=[]
              if(value>=10000){
                txt.push(value/10000+'w')
              }else{
                txt.push(value)
              }
              return txt
            },
            textStyle: {
              color: '#999', //坐标值得具体的颜色
            }
          },
          axisLine:{
              show:false//去除y轴线
          },
          axisTick:{
              show:false//去除y轴刻度
          },
        },
        series: [
            {
                name: '数据概览',
                type: 'bar',
                data:barChart2Info.data,
                // data: [2.0, 4.9, 7.0, 23.2, 25.6, 76.7, 135.6, 162.2, 32.6, 20.0, 6.4, 3.3],
                barWidth:16,//宽度
                itemStyle: {
                  //柱形图圆角，鼠标移上去效果，如果只是一个数字则说明四个参数全部设置为那么多
                  normal: {
                    //柱形图圆角，初始化效果
                    barBorderRadius:[15, 15, 0, 0],
                    show:true,
                    color: barChart2Info?.barColor || new this.$echarts.graphic.LinearGradient(
                        1, 0, 0, 1,
                        [
                            {offset: 0, color: '#4faefc'},
                            {offset: 1, color: '#187bfc'}
                        ]
                    ),
                    label: {
                      show: true,  //开启显示
                      position: 'top',  //在上方显示
                      textStyle: {  //数值样式
                        color: '#999',
                        fontSize: 12
                      },
                      rich:{
                        img:{
                          backgroundColor:{
                            image:hot
                          }
                        }
                      },
                      formatter:function (params) {
                        var txt=params.value
                        if(txt>=10000){
                          if(barChart2Info?.is_hot?.[params.dataIndex]){
                            txt = '{img|}'+(txt/10000).toFixed(0)+'w'
                          }else{
                            txt = (txt/10000).toFixed(0)+'w'
                          }
                        }
                        return txt
                      },
                    }
                  },
                },
                emphasis:barChart2Info?.emphasis || {
                    itemStyle:{
                        color:"#3092fc"//高亮
                    }
                },
                markLine: barChart2Info.hideMarkLine ? null: {
                    symbol:'none',
                    label:{
                      formatter:function (value) {
                        var txt=value.value
                        if(txt>=10000){
                          txt="均值"+(txt/10000).toFixed(0)+'w'
                        }
                        return txt
                      },
                      color:'#3092fc'
                    },
                    data: [
                        {type: 'average', name: '平均值'}
                    ]
                }
            }
        ],
        axisPointer:[{
            shadowStyle:{
                color:"rgba(255,255,255,0)"//阴影
            }
        }]
      })

      if(barChart2Info.triggerEvent){
        let _this = this
        myChart.on("click",function(params){
          // 添加处理方法 非公用的话建议在外部处理
          _this.$emit('xAxisClick',params)
        })
        myChart.on("dblclick",function(params){
          // 添加处理方法 非公用的话建议在外部处理
          _this.$emit('chartDblclick',params)
        })
      }

    }

  },
  components:{

  },
  watch:{

  },
  mounted() {
    this.barChart2(this.barChart2Info)
  }
}
</script>

<style scoped>


</style>